export const filterTamperingIssues = (issues, { search }) => {
    const query = search.trim().toLowerCase();
    if (query.length === 0)
        return issues;
    return issues.filter((issue) => issue.id.toLowerCase().includes(query) ||
        issue.description.toLowerCase().includes(query));
};
const PRIMARY_COMPARATOR = {
    id: (first, second) => first.id.localeCompare(second.id),
    files: (first, second) => first.count.violations - second.count.violations,
};
/** Sorts by the active column; ties break by rule ID ascending. */
export const sortTamperingIssues = (issues, { property, reverse }) => {
    const direction = reverse ? -1 : 1;
    const primary = PRIMARY_COMPARATOR[property];
    return [...issues].sort((first, second) => {
        const comparison = primary(first, second) * direction;
        return comparison !== 0 ? comparison : first.id.localeCompare(second.id);
    });
};
//# sourceMappingURL=utils.js.map